/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { challengeV4Schema } from '../getPublicChallengeBySlugV4/get-public-challenge-by-slug-v4-response';

export const exampleAudioSchema = z.object({
  exampleId: z.number(),
  audioUrl: z.string(),
});

export type IExampleAudio = z.infer<typeof exampleAudioSchema>;

export const challengeV5Schema = challengeV4Schema.extend({
  exampleAudios: z.array(exampleAudioSchema).default([]),
});

export type IChallengeV5 = z.infer<typeof challengeV5Schema>;

export const getPublicChallengeBySlugV5ResponseSchema = createApiResponseSchema(
  challengeV5Schema,
) as z.ZodSchema<IAPI<IChallengeV5>>;

export type IGetPublicChallengeBySlugV5Response = IAPI<IChallengeV5>;
